import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setIsAddPhotoWidgetOpen } from '@/store/slices/progressSlice';
import { useAppSelector } from '@/store/store';
import { useUploadingFiles } from '@/hooks/uploadingFiles/uploadingFiles.hook';
import {
    UPLOADING_FILES_AI_TASKS,
    UPLOADING_FILES_CONFIG,
} from '@/components/widgets/AddPhotoWidget/AddPhotoWidget.config';
import FullTipsBottomSheet from '@/components/widgets/AddPhotoWidget/FullTipsBottomSheet/FullTipsBottomSheet.component';
import MakePhotoBetterInfoModal from '@/components/widgets/AddPhotoWidget/MakePhotoBetterInfoModal/MakePhotoBetterInfoModal.component';
import PhotoAdviceModal from '@/components/widgets/AddPhotoWidget/PhotoAdviceModal/PhotoAdviceModal.component';
import SourceChooserBottomSheet from '@/components/widgets/AddPhotoWidget/SourceChooserBottomSheet/SourceChooserBottomSheet.component';
import { TASK_STATUSES_LOADING, TaskStatusT } from '@/constants/statuses';

const AddPhotoWidget: FC = () => {
    const dispatch = useDispatch();
    const { uploadFiles } = useUploadingFiles(UPLOADING_FILES_CONFIG);
    const { progressStatus, isAddPhotoWidgetOpen } = useAppSelector(
        (state) => state.progressSlice,
    );

    const [isShowFullTipsBottomSheet, setIsShowFullTipsBottomSheet] =
        useState<boolean>(false);
    const [isMakePhotoBetterModalOpen, setIsMakePhotoBetterModalOpen] =
        useState<boolean>(false);
    const [isPhotoAdviceModalOpen, setIsPhotoAdviceModalOpen] =
        useState<boolean>(false);

    const isDisabled =
        !!progressStatus &&
        Object.values<TaskStatusT>(TASK_STATUSES_LOADING).includes(
            progressStatus,
        );

    const closeWidgetHandler = (): void => {
        dispatch(setIsAddPhotoWidgetOpen(false));
    };

    const addFiles = async (files: File[]): Promise<void> => {
        uploadFiles(files, UPLOADING_FILES_AI_TASKS);
        setIsShowFullTipsBottomSheet(false);
        setIsMakePhotoBetterModalOpen(false);
        setIsPhotoAdviceModalOpen(false);
        closeWidgetHandler();
    };

    const handlePhotoAdviceClose = (
        isShowNext?: boolean,
        isFullClose?: boolean,
    ): void => {
        setIsPhotoAdviceModalOpen(false);

        if (isShowNext) {
            setIsShowFullTipsBottomSheet(true);
        }

        if (isFullClose) {
            closeWidgetHandler();
        }
    };

    return (
        <>
            {isAddPhotoWidgetOpen && (
                <SourceChooserBottomSheet
                    addFiles={addFiles}
                    isDisabled={isDisabled}
                    onClose={closeWidgetHandler}
                    openPhotoAdviceModal={() => setIsPhotoAdviceModalOpen(true)}
                    openMakePhotoBetterModal={() =>
                        setIsMakePhotoBetterModalOpen(true)
                    }
                    openFullTipsBottomSheet={() =>
                        setIsShowFullTipsBottomSheet(true)
                    }
                />
            )}
            {isPhotoAdviceModalOpen && (
                <PhotoAdviceModal
                    addFiles={addFiles}
                    onclose={handlePhotoAdviceClose}
                />
            )}
            {isMakePhotoBetterModalOpen && (
                <MakePhotoBetterInfoModal
                    onclose={() => setIsMakePhotoBetterModalOpen(false)}
                />
            )}
            {isShowFullTipsBottomSheet && (
                <FullTipsBottomSheet
                    onClose={() => setIsShowFullTipsBottomSheet(false)}
                />
            )}
        </>
    );
};

export default AddPhotoWidget;
